export let PREVIEW_TYPES = /*#__PURE__*/function (PREVIEW_TYPES) {
  PREVIEW_TYPES[PREVIEW_TYPES["NONE"] = 0] = "NONE";
  PREVIEW_TYPES[PREVIEW_TYPES["THUMBNAILS_HOVER"] = 1] = "THUMBNAILS_HOVER";
  PREVIEW_TYPES[PREVIEW_TYPES["MENU"] = 2] = "MENU";
  PREVIEW_TYPES[PREVIEW_TYPES["NAVIGATION_ARROWS"] = 3] = "NAVIGATION_ARROWS";
  PREVIEW_TYPES[PREVIEW_TYPES["ACTION_BAR"] = 4] = "ACTION_BAR";
  return PREVIEW_TYPES;
}({});
//# sourceMappingURL=preview-types.js.map